// eslint-disable-next-line max-classes-per-file
import { Record, Map, List as ImmutableList } from 'immutable';
import { DateTime } from 'luxon';
import { mkChartOfAccount } from 'data/chartOfAccounts/types';
import { mkTag } from 'data/tags/types';

// Notes: Transactions are stored first by accountId and then by txnId. So,
//        there is a map of transactionsByAccountId where each value in the
//        map is the TransactionsForAccount record which then contains a map of
//        the transactions by txnId.
//
export const TransactionStore = new Record({
  loadPending: true,   // has a load occurred ever?
  error: undefined,    // error ocurred during last operation
  isLoading: false,    // is loading now
  transactionsByAccountId: new Map(),
  lastSyncDate: 0,
  lastUpsertId: null,
  lastReductions: null,
});

export const BaseSplitItem = ({ tags, coa, ...defaultValues }) => class extends Record({

  id: defaultValues.id || null,
  clientId: null,
  memo: null,
  tags: new ImmutableList([]),
  coa: mkChartOfAccount({
    id: '0',
    type: 'UNCATEGORIZED',
  }),
  amount: 0.00,
  transfer: null,

  ...defaultValues,

}) { };

export const BaseSplit = (defaultValues) => class extends Record({

  items: null,

  ...defaultValues,

}) { };

export class Split extends BaseSplit({

}) { }

export class SplitItem extends BaseSplitItem({

}) { }

export const mkSplit = (split) => {
  const ret = new Split({
    items: mkSplitItems(split.items),
  });
  return ret;
};

export const mkSplitItem = (item) =>
  new SplitItem({
    ...item,
    tags: item.tags ? new ImmutableList(item.tags.map((tag) => mkTag(tag))) : undefined,
    coa: item.coa ?
      mkChartOfAccount({ id: item.coa.id, type: item.coa.type }) :
      null,
  });


export function mkSplitItems(items) {
  return new ImmutableList(items.map((item) => mkSplitItem(item)));
}

export function mkSplitCopy(split) {
  if (split?.items) {
    const newSplit = split.set('items', split.items.map((item) => item.set('id', undefined)));
    return mkSplit(newSplit);
  }
  return split;
}
export const Transaction = (defaultValues) => class extends Record({
  id: '0',

  accountId: undefined,
  clientId: undefined, // this is a ONE TIME instantiation, don't do this.  uuidv4().toUpperCase(),
  postedOn: DateTime.local().toISODate(),
  postedOnAsUnix: undefined,

  payee: undefined,
  memo: undefined,
  coa: mkChartOfAccount({
    id: '0',
    type: 'UNCATEGORIZED',
  }),
  amount: 0.00,
  split: undefined,

  tags: undefined,
  attachments: undefined,

  state: 'PENDING',
  matchState: 'NOT_MATCHED',
  isReviewed: undefined,
  transfer: undefined,

  cpData: undefined,

  stModelId: undefined,
  stDueOn: undefined,
  paymentProvider: undefined,

  source: 'USER_ENTERED',
  isDeleted: false,
  modifiedAt: undefined,

  isExcludedFromReports: false,
  isExcludedFromF2S: false,

  userFlag: undefined,
  userFlagNote: undefined,

  matchedTxnId: undefined,

  isBill: false,
  isSubscription: false,

  // fields specific to web app (unknown to QCS)
  //
  balance: undefined,

  ...defaultValues,

}) { };

export class CashFlowTransaction extends Transaction({
  type: 'CASH_FLOW',
  check: {
    number: '',
    memo: '',
  },
  coordinates: null,
}) { }


export const statusOrder = ['RECONCILED', 'CLEARED', 'PENDING'];


